import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



// Async thunk to fetch exam details
export const fetchExams = createAsyncThunk(
  "exams/fetchExams",
  async ({ userId, token }, { rejectWithValue }) => {
    const API_URL = "https://77qd01vu2f.execute-api.us-east-1.amazonaws.com/sqa/get-exam-details";
    try {
      const response = await axios.post(API_URL, { user_id: userId }, {
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` }
      });
      return response.data; // Response is an array of exam details
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Failed to fetch exams");
    }
  }
);


// Create Exam
export const createExam = createAsyncThunk(
  "exams/createExam",
  async ({ userId, token, examType }, { rejectWithValue }) => {
    try {
      const API_URL = "https://bmkdw93swh.execute-api.us-east-1.amazonaws.com/sqa/create-exam-function";
      const response = await axios.post(API_URL, { user_id: userId, exam_type: examType }, {
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` }
      });
      const data = await response.data;

      if (response.status !== 200) {
        throw new Error(data.message || "Failed to create exam");
      }
      return { data, status: response.status };
    } catch (error) {
      console.log("error", error);
      return rejectWithValue(error.message);
    }
  }
);

const examSlice = createSlice({
  name: "exams",
  initialState: {
    exams: [],
    loading: false,
    error: null,
  },
  reducers: {}, // No manual reducers needed
  extraReducers: (builder) => {
    builder
      .addCase(fetchExams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExams.fulfilled, (state, action) => {
        state.loading = false;
        state.exams = action.payload;
      })
      .addCase(fetchExams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default examSlice.reducer;
